export const WAREHOUSING_REASONS = [
  {name: 'Lieferung', label: 'Lieferung', default: false},
  {name: 'Überbestand', label: 'Überbestand', default: false},
  {name: 'Bestandskorrektur', label: 'Bestandskorrektur', default: false},
  {name: 'Sonstiges', label: 'Sonstiges', default: true},
];


// WEBPACK FOOTER //
// ./src/app/store-management/warehousing-reasons.enum.ts